import { datadogRum } from '@datadog/browser-rum';

export function trackSignup(practiceId: string) {
  datadogRum.addAction('signup_completed', { practiceId });
}

export function trackVisitCreated(medium: string, type: 'instant' | 'scheduled') {
  datadogRum.addAction('visit_created', { medium, type });
}

export function trackPatientJoined(medium: string) {
  datadogRum.addAction('patient_joined', { medium });
}

export function trackBookingStep(step: string) {
  datadogRum.addAction('booking_step', { step });
}

export function trackBookingCompleted(practiceId: string) {
  datadogRum.addAction('booking_completed', { practiceId });
}
